import {AppState} from '../states/app.state';
import {identity} from 'rxjs';
import {createSelector} from '@ngrx/store';


export class KundeDialogSelectors {

  /**
   * Die `select`-Eigenschaft ist ein Objekt, das Funktionen definiert, jede Funktion selektiert eine
   * bestimmte Eigenschaft aus dem State.
   * Das sind grundlegende Selektoren, die im ganzen Projekt als Bausteine für komplexere Selektoren wiederverwendet
   * werden können.
   */
  private static select = {
    isOpen: (state: AppState) => state.kundenDialog.isOpen,
    kunde: (state: AppState) => state.kundenDialog.kunde,
    addToIncoice: (state: AppState) => state.kundenDialog.addToBeleg,
    kundenarten: (state: AppState) => state.kundenDialog.kundenarten,
    addToBeleg: (state: AppState) => state.kundenDialog.addToBeleg,
    gutschriftFieldsRequired: (state: AppState) => state.kundenDialog.gutschriftFieldsRequired,
  };

  public static isKundeDialogOpen = createSelector(
    this.select.isOpen,
    identity,
  );

  public static kunde = createSelector(
    this.select.kunde,
    identity,
  );

  public static addToBeleg = createSelector(
    this.select.addToBeleg,
    identity,
  );

  public static kundenarten = createSelector(
    this.select.kundenarten,
    identity,
  );

  public static gutschriftFieldsRequired = createSelector(
    this.select.gutschriftFieldsRequired,
    identity,
  );

}
